export const QUEUE_INIT = 'QUEUE_INIT'
export const QUEUE_SAVE = 'QUEUE_SAVE'
export const QUEUE_UPDATE = 'QUEUE_UPDATE'
export const QUEUE_SELECT_TAB = 'QUEUE_SELECT_TAB'
